import {DataTableColumn} from "mantine-datatable";
import {Order} from "../types.ts";
import {Text} from '@mantine/core';
import {Link} from 'react-router-dom';

export const useTableColumns = (context: 'customer' | 'reports' = 'reports') => {

    const columns: DataTableColumn<Order>[] = [
        {
            accessor: 'id',
            title: 'Order ID',
            render: (record: Order) => (
                <Link to={`/customers/${record.customerId}/orders/${record.id}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.id}
                    </Text>
                </Link>
            )
        },
        ...(context === 'reports' ? [{
            accessor: 'customer',
            title: 'Customer',
            render: (record: Order) => (
                <Link to={`/customers/${record.customerId}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.customerId}
                    </Text>
                </Link>
            )
        }] : []),
        {
            accessor: 'subscriptionId',
            title: 'Subscription ID',
            render: (record: Order) => (
                <Link to={`/customers/${record.customerId}/subscriptions/${record.subscriptionId}`} style={{ textDecoration: 'none' }}>
                    <Text c="blue" style={{ cursor: 'pointer' }}>
                        {record.subscriptionId}
                    </Text>
                </Link>
            )
        },
        {
            accessor: 'created',
            title: 'Created',
            render: (record: Order) => (
                <Text size="sm">
                    {record.created ? new Date(record.created).toLocaleDateString() : '-'}
                </Text>
            )
        },
    ];

    return {
        columns,
    }
}